export const ContactsSliceConstants = {
  SendMessage: 'sendMessage',
};
